export default __webpack_public_path__ + "static/media/image4.338513ea.jpg";